import { API_BASE_URL } from "../lib/config";
import type { User } from "../types/user";

export async function fetchUsersApi(token: string): Promise<User[]> {
  const response = await fetch(`${API_BASE_URL}/api/admin/users`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch users list");
  }
  return data;
}

export async function updateSubscriptionApi(token: string, userId: number, status: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/api/admin/users/${userId}/subscription`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ subscription_status: status }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to update user subscription");
  }
  return data;
}

export interface VisitorMessage {
  id: number;
  content: string;
  created_at: string;
}

export async function fetchMessagesApi(token: string): Promise<VisitorMessage[]> {
  const response = await fetch(`${API_BASE_URL}/api/admin/messages`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch visitor messages");
  }
  return data;
}
